import type { ActivityEvent } from '@shared/components/panels/components/domain-sections/Activity/types'

/**
 * Mock activity events for the invoice Activity section.
 */
export const MOCK_INVOICE_ACTIVITY_EVENTS: ActivityEvent[] = [
  {
    id: 'inv-activity-payment-001',
    type: 'payment_captured',
    title: 'Payment received',
    description: 'Payment of $1,250.00 received via bank transfer.',
    timestamp: '2025-10-15T11:20:00Z',
    timestampDisplay: '15 Oct 2025 11:20',
    severity: 'info',
    requiresAction: false,
    icon: 'credit-card',
  },
  {
    id: 'inv-activity-sent-001',
    type: 'payment_created',
    title: 'Invoice sent',
    description: 'Invoice emailed to customer@example.com.',
    timestamp: '2025-10-01T09:15:00Z',
    timestampDisplay: '1 Oct 2025 09:15',
    severity: 'info',
    requiresAction: false,
    icon: 'receipt',
    details: [
      { action: 'Email delivered', timestamp: '1 Oct 2025 09:16' },
      { action: 'Email opened by recipient', timestamp: '1 Oct 2025 10:42' },
    ],
  },
  {
    id: 'inv-activity-created-001',
    type: 'payment_created',
    title: 'Invoice created',
    description: 'Invoice INV-2025-001 created as draft.',
    timestamp: '2025-09-28T14:30:00Z',
    timestampDisplay: '28 Sep 2025 14:30',
    severity: 'info',
    requiresAction: false,
    icon: 'file-text',
  },
]

/**
 * Mock activity events for the payment Activity section.
 * Events are ordered most-recent-first (index 0 is shown when collapsed).
 */
export const MOCK_ACTIVITY_EVENTS: ActivityEvent[] = [
  {
    id: 'activity-fraud-001',
    type: 'fraud_alert',
    title: 'Fraud alert',
    description: 'Automated fraud detection flagged this payment. Risk signals: IP mismatch, new card, high amount.',
    timestamp: '2025-09-10T16:05:00Z',
    timestampDisplay: '10 Sep 2025 16:05',
    severity: 'error',
    requiresAction: true,
    actionLabel: 'Resolve alert',
    actionCompleted: false,
    icon: 'shield-alert',
    statusCard: {
      title: 'Fraud alert active',
      timestampDisplay: '10 Sep 2025 16:05',
      description: 'ML model detected suspicious pattern. Resolve as false positive or escalate to the appropriate team.',
    },
  },
  {
    id: 'activity-review-001',
    type: 'payment_under_review',
    title: 'Payment under review',
    description: 'This payment has been flagged for manual review due to elevated risk score.',
    timestamp: '2025-09-10T15:30:00Z',
    timestampDisplay: '10 Sep 2025 15:30',
    severity: 'warning',
    requiresAction: true,
    actionLabel: 'Review payment',
    actionCompleted: false,
    icon: 'shield-alert',
    statusCard: {
      title: 'Under review',
      timestampDisplay: '10 Sep 2025 15:30',
      description: 'Payment flagged by Sonar rule: risk_level = elevated. Please approve or decline.',
    },
  },
  {
    id: 'activity-dispute-001',
    type: 'dispute_received',
    title: 'Disputed',
    description: 'Cardholder filed a dispute for $4,235.00. Reason: Product not received.',
    timestamp: '2025-09-10T14:56:00Z',
    timestampDisplay: '10 Sep 2025 14:56',
    severity: 'warning',
    requiresAction: true,
    actionLabel: 'Submit evidence',
    actionCompleted: false,
    icon: 'zap',
    statusCard: {
      title: 'Initiated',
      timestampDisplay: '10 Sep 2025 08:23',
      description: 'Please submit supporting evidence by 30 Sep 2024 12:45 to defend the charge.',
    },
    winProbability: 85,
    additionalActions: [
      { label: 'Assign', variant: 'outline' },
      { label: '', variant: 'more' },
    ],
    subEvents: [
      { id: 'sub-countered-001', title: 'Countered', timestampDisplay: '10 Sep 2025 08:23' },
      { id: 'sub-evidence-001', title: 'John Doe submitted evidence', timestampDisplay: '10 Sep 2025 08:23' },
    ],
  },
  {
    id: 'activity-created-001',
    type: 'payment_created',
    title: 'Payment started',
    timestamp: '2025-09-10T14:56:00Z',
    timestampDisplay: '10 Sep 2025 14:56',
    severity: 'info',
    requiresAction: false,
    icon: 'credit-card',
    details: [
      { action: 'Card tokenized', timestamp: '10 Sep 2025 14:56' },
      { action: '3DS authentication initiated', timestamp: '10 Sep 2025 14:57' },
      { action: 'Authorization approved', timestamp: '10 Sep 2025 14:58' },
    ],
  },
]
